module.exports = __webpack_public_path__ + "static/media/place.d09bd3bb.png";